export default "__VITE_ASSET__DhmVGBOx__"